/*                                                                                         */
/*                                                                                          */
/*                                                                                         */
/*                                                                                           */
/*                                                                                 */
/*                                                                                     */
/*                                                                                         */
/*                                                                                      */
/*                                   */
import ky from "ky";
import { isHTTPError } from "@otto-ec/global-resources/ky";
import { createLogger, kyTimeoutLoggingHook } from "utils/logging";
import type { FetchRetryArgs } from "./fetch.ts";

export async function kyFetch(args: FetchRetryArgs): Promise<Response> {
	const {
		url,
		namespace,
		timeout,
		retryOptions: { limit },
		fetchOptions,
	} = args;

	const logger = createLogger(namespace, "fetch-retry");

	try {
		return await ky(url, {
			retry: { limit, retryOnTimeout: true, methods: ["get", "post", "put", "query"] },
			timeout: timeout ?? false,
			hooks: {
				beforeError: [kyTimeoutLoggingHook(logger, url)],
			},
			...fetchOptions,
		});
	} catch (error) {
		if (isHTTPError(error)) {
			return error.response;
		}
		throw error;
	}
}
